import {
    mapAttachmentsForOne,
    mapAuthorForOne,
    mapFeedItem,
    mapPlatformsForOne,
    mapProductsForList,
    mapProductsForOne,
    mapSalesChannelsForOne,
    mapStatesForList,
    mapStatesForOne,
} from './common';

function mapCategoriesforOne(responseData) {
    return {
        categories: responseData.categories.map((c) => c.slug),
    };
}

function mapCategoriesForList(data) {
    return {
        categories: data.categories.map((category) => ({
            id: category.slug,
            name: category.name,
        })),
    };
}

function mapGetOneArticleData(responseData) {
    return {
        ...responseData,
        ...mapAuthorForOne(responseData),
        ...mapCategoriesforOne(responseData),
        ...mapSalesChannelsForOne(responseData),
        ...mapPlatformsForOne(responseData),
        ...mapProductsForOne(responseData),
        ...mapStatesForOne(responseData),
        ...mapFeedItem(responseData),
        ...mapAttachmentsForOne(responseData),
    };
}

function mapGetListArticlesData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapCategoriesForList(data),
        ...mapProductsForList(data),
        ...mapStatesForList(data),
    }));
}

export { mapGetOneArticleData, mapGetListArticlesData };
